<template>
	<section class="section login">
		<div class="columns is-centered">
			<div class="column is-6 is-4-fullhd">
				<h4 class="title is-left">{{ $t('Login') }}</h4>
				<b-field :label="$t('E-mail')" label-for="email">
					<b-input
						:placeholder="$t('E-mail')"
						type="email"
						v-model="user.email"
						:counter="10"
						icon="envelope"
						@keyup.enter.native="login"
						id="email"
					></b-input>
				</b-field>
				<b-field :label="$t('Password')" label-for="password">
					<b-input
						type="password"
						value="password"
						v-model="user.password"
						@keyup.enter.native="login"
						password-reveal
						id="password"
					></b-input>
				</b-field>
				<b-button type="is-primary" @click="login">{{ $t('Login') }}</b-button>
				<hr>
				<div class="box has-text-centered">
					<p>
						{{ $t('If you are not already a registered user of this site, please register now.') }}
					</p>
					<b-button
						v-if="this.$i18n.locale == 'hu'"
						type="is-primary"
						outlined
						@click="register"
						>{{ $t('Register') }}</b-button
					>
					<b-button
						v-else
						type="is-primary"
						outlined
						@click="register"
						>{{ $t('Register') }}</b-button
					>
					<hr>
					<p>
						{{ $t('Forgot your password? No problem. Reset your password here.') }}
					</p>
					<b-button
						v-if="this.$i18n.locale == 'hu'"
						type="is-primary"
						outlined
						@click="passwordReset"
						>{{ $t('Password reset') }}</b-button
					>
					<b-button
						v-else
						type="is-primary"
						outlined
						@click="passwordReset"
						>{{ $t('Password reset') }}</b-button
					>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: 'Login',
	components: {},
	metaInfo () {
		return {
			title: this.$t("Login"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			user: {
				email: '', //"devtest@smartsector.hu",
				password: '', //"aaa123"
			},
			rules: {
				required: (value) => !!value || 'Required.',
				min: (v) => v.length >= 8 || 'Min 8 characters',
				emailMatch: () => "The email and password you entered don't match",
			},
			password: 'Password',
		}
	},
	methods: {
		login: function () {
			var _this = this
			this.$http
				.post('/users/login', this.user)
				.then((response) => {
					//console.log("user/login:", response, _this.$socket.id);
					_this.$http.defaults.headers.Authorization = response.data.token
					localStorage.setItem('token', response.data.token)
					console.log('____login data:', response.data)
					if (response.data.user.UserPreference) {
						localStorage.setItem('lang', response.data.user.UserPreference.language)
						localStorage.setItem('currency', response.data.user.UserPreference.currency)
					}
					localStorage.setItem('loggedIn', true)
					_this.$store.commit('setToken', response.data.token)
					_this.$store.commit('setUser', response.data.user)
					_this.$store.commit('setLoggedIn', true)
					_this.$store.commit('setRole', response.data.user.role)
					_this.$buefy.snackbar.open({
						message: _this.$t('Successful login'),
						position: 'is-top',
						queue: false,
					})
					console.log('ROUTE', _this.$route)
					_this.$router.replace({ path: '/' })
				})
				.catch((error) => {
					console.log(error)
					_this.$buefy.snackbar.open({
						message: _this.$t('Failed login'),
						type: 'is-danger',
						position: 'is-top',
						duration: 5000,
						queue: false,
					})
				})
		},
		register: function () {
			var _this = this
			_this.$router.push({name:'Register'})
		},

		passwordReset: function () {
			var _this = this
			_this.$router.push({name:'ForgetPass'})
		}
	},
}
</script>
